import Radio from '../radio/index.jsx'
import { useState } from 'react'
import Selector from '../selector/index.jsx'
import EffectDisplay from '../effectDisplay/index.jsx'
import './side.less'
import React from 'react'
console.log(React)
export default function TopVideoSide(props) {
  const [ifon, setIfon] = useState({
    space: props.ifon.ad_location,
    options: [{ text: '常规广告', id: 0, transverse: 'https://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-regular-video-horizontal.png', vertical: '	https://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-regular-video-vertical.png' }, { text: '卡片广告', id: 1, src: 'https://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-card.png' }],
    activeId: props.ifon.outer_style,
    videoType: '1',
    videoSize: '1'
  })

  return (<div className='topVideoSide'>
    <div className='side_no1'>
      <h3 className='no1_title'>顶部组件：视频</h3>
      <div className='no1_box'>支持腾讯广告全广告位</div>
    </div>
    <div className='side_no2'>
      <p className='no2_p'>投放朋友圈信息流，广告外层将自动拉取顶部视频。</p>
      <p className='no2_p'>投放公众号及腾讯广告其他媒体广告位，将不会拉取。</p>
    </div>
    <div className='side_no3'>
      <h3 className='no3_title'>广告位与样式</h3>
      <div className='no3_box'>
        <div className='box'>
          <span className='box_title'>广告位</span>
          <div className='box_box'>
            <div className='box_item1'>
              <Radio radio={ifon.space} label={'sns'} change={(label) => {
                setIfon({
                  ...ifon,
                  space: label
                })
                props.mySetIfon && props.mySetIfon({
                  ...props.ifon,
                  ad_location: 'sns'
                })
              }}>朋友圈信息流</Radio>
            </div>
            <div className='box_item1'>
              <Radio radio={ifon.space} label={'gzh'} change={(label) => {
                setIfon({
                  ...ifon,
                  space: label
                })
                props.mySetIfon && props.mySetIfon({
                  ...props.ifon,
                  ad_location: 'gzh'
                })
              }}>公众号及及腾讯广告其他媒体广告位</Radio>
            </div>
          </div>
        </div>

        {ifon.space === 'sns' && <div className='box'>
          <span className='box_title'>外层样式</span>
          <div className='div_box'>
            <Selector options={ifon.options} activeId={ifon.activeId} change={(item) => {
              setIfon({
                ...ifon,
                activeId: item.id
              })
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                outer_style: item.id
              })
            }}></Selector>
          </div>
        </div>}

        {(ifon.space === 'sns' && ifon.activeId === 0) && <div className='box'>
          <span className='box_title'>视频类型</span>
          <div className='box_item2'>
            <div className='item'>
              <Radio radio={ifon.videoType} label={'1'} change={(label) => {
                setIfon({
                  ...ifon,
                  videoType: label
                })
              }}>横版视频</Radio>
            </div>
            <div className='item'>
              <Radio radio={ifon.videoType} label={'2'} change={(label) => {
                setIfon({
                  ...ifon,
                  videoType: label
                })
              }}>竖版视频</Radio>
            </div>
          </div>
        </div>}

        {(ifon.space === 'sns' && ifon.activeId === 0 && ifon.videoType === '2') && <div className='box'>
          <span className='box_title'>视频尺寸</span>
          <div className='box_box'>
            <div className='box_item1'>
              <Radio radio={ifon.videoSize} label={'1'} change={(label) => {
                setIfon({
                  ...ifon,
                  videoSize: label
                })
              }}>750像素 × 1536像素</Radio>
            </div>
            <div className='box_item1'>
              <Radio radio={ifon.videoSize} label={'2'} change={(label) => {
                setIfon({
                  ...ifon,
                  videoSize: label
                })
              }}>750像素 × 1536像素</Radio>
            </div>
            <div className='box_item1'>
              <Radio radio={ifon.videoSize} label={'3'} change={(label) => {
                setIfon({
                  ...ifon,
                  videoSize: label
                })
              }}>750像素 × 1536像素</Radio>
            </div>
          </div>
        </div>}

      </div>
    </div>

    <div className='side_no3'>
      <h3 className='no3_title'>视频规格</h3>
      <div className='no3_box'>
        <p className='box_p1'>视频会同步作为朋友圈外层视频<br />视频自动循环播放</p>
        <p className='box_p2'>视频尺寸：1280 * 720像素 / 1280 * 960像素<br />视频大小：≤100MB<br />视频长度：5-90秒</p>
      </div>
    </div>
    {ifon.space === 'sns' && <EffectDisplay src={ifon.space === 'sns' && ifon.activeId === 0 ? ifon.videoType === '1' ? ifon.options[0].transverse : ifon.options[0].vertical : ifon.options[1].src}>查看外层广告位效果</EffectDisplay>}

  </div>)
}
